module.exports = __webpack_public_path__ + "static/img/image_qyjs_3.0cf4652.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PC/image_qyjs_3.png
// module id = DQoY
// module chunks = 1